import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import LoginImageBanner from "../LoginImgBanner";
import logo from "../../images/kegow-color.png";

function SecurityPin() {
  const history = useHistory();

  const [securityPin, setSecurityPin] = useState({
    security_pin: "",
    confirm_security_pin: "",
  });
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setSecurityPin({ ...securityPin, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // prevents loader from rendering if PINS don't match
    if (securityPin.security_pin !== securityPin.confirm_security_pin) {
      toast.error("Security PINs do not match!");
      return;
    }
    setIsSubmitting(true);
    history.push("/register", {
      securityPin: securityPin.security_pin,
      confirmSecurityPin: securityPin.confirm_security_pin,
    });
  };

  useEffect(() => {
    Object.values(securityPin).includes("")
      ? setAreFieldsSet(false)
      : setAreFieldsSet(true);
  }, [securityPin]);

  return (
    <>
      <section className="login-page row min-vh-100 d-flex mt-6 mt-md-0 flex-row">
        <LoginImageBanner />

        <div className="d-flex col-12 align-items-center col-md-6">
          <div className="p-7 container me-md-4">
            <img
              className="keg-login-logo mb-6 mb-md-6"
              src={logo}
              alt="kegow-pic"
            />
            <h1 className="mb-0 fw-medium text-primary">Security Pin</h1>
            <p className="mb-6">Please set a Security PIN.</p>
            <form className="mb-6" onSubmit={handleSubmit}>
              <div className="form-group mb-5">
                <label className="form-label" htmlFor="security_pin">
                  Security PIN
                </label>
                <input
                  id="security_pin"
                  type="password"
                  className="form-control form-control-user"
                  placeholder="Enter Security PIN"
                  onChange={handleChange}
                  title="Numbers only, e.g. 1234"
                  maxLength="4"
                  minLength="4"
                  pattern="[0-9]{4}"
                  required
                />
              </div>
              <div className="form-group mb-5">
                <label className="form-label" htmlFor="confirm_security_pin">
                  Confirm Security PIN
                </label>
                <input
                  id="confirm_security_pin"
                  type="password"
                  className="form-control form-control-user"
                  placeholder="Confirm Security PIN"
                  onChange={handleChange}
                  title="Numbers only, e.g. 1234"
                  maxLength="4"
                  minLength="4"
                  pattern="[0-9]{4}"
                  required
                />
              </div>
              {areFieldsSet ? (
                isSubmitting ? (
                  <button className="btn w-100 btn-primary">
                    <Loader type="Oval" color="#fff" width={20} height={20} />
                  </button>
                ) : (
                  <button className="btn w-100 btn-primary" type="submit">
                    Next
                  </button>
                )
              ) : (
                <button
                  className="btn w-100 btn-primary"
                  type="button"
                  disabled
                >
                  Next
                </button>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default SecurityPin;
